import React from 'react';
import { useSelector } from 'react-redux';
import SquareContainer from 'ugc/components/ugcGallery/square/SquareContainer';
import useGetGalleryMediaList from 'ugc/hooks/useGetGalleryMediaList';
import Loading from 'client/components/Loading';
import { useHeightResizePostMessage } from 'client/hooks/useHeightResizePostMessage';

export default function WrapperSquare({ data }) {
    const { promoIdOfUgcLink: promoId, uuid: promoUUID } = useSelector(s => s.promo);
    const buttonClickLink = `/ugc/${promoId}${window.location.search}${window.location.hash}`;
    const clientBodyRef = useHeightResizePostMessage({ useMaxSize: true });
    const { galleryMediaList, isInit, setIsInit } = useGetGalleryMediaList(promoUUID);
    const square = transformSquare(galleryMediaList);

    function transformSquare(mediaList) {
        let seqCounter = 1;
        return mediaList.map(d => ({
            memberId: d.serialNo,
            avatar: '',
            title: '',
            ugcAuthorName: '',
            media: [
                {
                    result: d.value,
                    seq: seqCounter++,
                    subtype: '',
                    type: d.type
                }
            ]
        }));
    }

    return (
        <>
            {!isInit && <Loading />}
            {square.length > 0 && (
                <SquareContainer
                    config={data.settingGame.galleryGameSetting}
                    clientBodyRef={clientBodyRef}
                    data={square}
                    buttonLink={buttonClickLink}
                    isInit={isInit}
                    setIsInit={setIsInit}
                />
            )}
        </>
    );
}
